
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/kredit-laptop",
      function () {
        return require("private-next-pages/kredit-laptop.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/kredit-laptop"])
      });
    }
  